export default __webpack_public_path__ + "static/media/whiteTick.efc0b778.svg";